import { ChangeTempPasswordType } from '@api/types';
import { useChangeTempPasswordMutation } from '@config/state/globalSlices/apiSlice/mutations';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { createNotification } from '@shared/utils/createNotification';
import { passwordFormSchema } from 'compositions/auth/Form/schemas';
import { Form,Formik } from 'formik';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, } from 'react-router-dom';

import AuthHeader from '../Components/AuthHeader';
import Input from '../Components/Input';
import SubmitButton from '../Components/SubmitButton';

const initialValues = {
  password: '',
  confirmPassword: '',
};

export default function NewUserSetPassword() {

  const navigate = useNavigate();
  const { state } = useLocation();

  const [submitForm, { isLoading: isSubmitting, isSuccess }] = useChangeTempPasswordMutation();

  const sessionId = state?.sessionId;
  const username = state?.username;
  const media = useMediaQuery('(max-width: 600px)')

  useEffect(() => {
    if (!sessionId || !username) {
      // navigate('/ap/login');
    }
  }, [sessionId, username, navigate]);

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      const val = {
        sessionId,
        newPassword: values.password,
        username,
      } as ChangeTempPasswordType;
      await submitForm(val).unwrap();
      createNotification({
        message: 'Success! Your password has been set. You can now log in with your new password.',
        type: 'success',
        position: media ? 'top-center' :'bottom-center',

      });
      navigate('/ap/login');

    } catch (error){

      createNotification({
        message: 'Session expired. Please re-login with your temporary password and try again.',
        type: 'error',
        position: media ? 'top-center' :'bottom-center',

      });
      navigate('/ap/login');
    }
  };
  return (
    <div className="w-full">

      <Helmet title="PHMG | Set A Password" />
      <AuthHeader title="Welcome, it's time to set a new password" marginTop='mt-0' marginBottom='mb-2'/>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={passwordFormSchema}>
        {({ errors }) => ( <Form className='text-[14px]'>

          <Input error={errors?.password} label="New password" name='password' placeholder="" type="password" showToggle />
          <Input error={errors?.confirmPassword} label="Confirm password" name="confirmPassword" showToggle placeholder="" type="password" />

          <SubmitButton text="Set new password" type="submit" disabled={isSubmitting || isSuccess} />
        </Form>)}
      </Formik>

    </div>)

}
